import React from "react";
import "./VendorWebPage.css";
import { Button, Col, Row } from "antd";
import layer from "../../../Images/Layer_1.png";
import vec from "../../../Images/Vector.png";
import brush from "../../../Images/mdi_brush.png";
import draw from "../../../Images/mdi_draw.png";
import group2 from "../../../Images/Group 427319016 (2).png";
import group1 from "../../../Images/Group 427319016 (1).png";
import group from "../../../Images/Group 427319016.png";
import { useNavigate, useParams } from "react-router-dom";

const VendorWebPage = () => {
  const navigate = useNavigate();
  const { vendorClientId } = useParams();

  console.log("vendorClientId", vendorClientId);

  return (
    <>
      <div className="Col-1">
        <div className="containerfirst">
          <Row className="firstBox">
            <Col>
              <img alt="capsi" src={layer} className="logo" />
            </Col>
            <Col>
              <h1>
                <span className="capfont">Capsi</span>
                <span className="bookF">Books</span>
              </h1>
            </Col>
          </Row>
          <div>
            <p className="p1">Connecting Suppliers with Opportunities</p>
            <p className="p2">
              Your One-Stop Platform for Registration and Bidding Success
            </p>
          </div>

          <div style={{ marginTop: "70px" }}>
            <Row justify={"center"}>
              <Col>
                <Button
                  onClick={() =>
                    navigate(`/vendor/clients/${vendorClientId}/logIn`)
                  }
                  className="firstbtn"
                >
                  Start Bidding Now
                </Button>
              </Col>
              <Col>
                <Button
                  className="secbtn"
                  onClick={() =>
                    navigate(`/vendor/clients/${vendorClientId}/registration`)
                  }
                >
                  Register Now
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div>
        <div className="containerfirst" style={{ textAlign: "center" }}>
          <h2 className="feat">Features</h2>
          <p className="p3">
            Most Calendars are designed for teams. slate is designed for
            freelancers
          </p>
        </div>
      </div>

      <div className="box3">
        <div
          className="containerfirst"
          style={{
            // display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Row
            justify="space-around"
            // gutter={16}
            style={{ textAlign: "center", alignItems: "baseline" }}
          >
            <Col>
              <img src={vec} alt="img" />
              <h2 className="boxh">Register</h2>
              <p className="p4">
                Create your profile with essential business details to become a
                verified supplier on our platform.
              </p>
            </Col>
            <Col>
              <img src={draw} alt="img" />
              <h2 className="boxh">Bid</h2>
              <p className="p4">
                Explore live and upcoming bids tailored to your field.
              </p>
            </Col>
            <Col>
              <img src={brush} alt="img" />
              <h2 className="boxh">Succeed</h2>
              <p className="p4">
                With every successful bid grow your business, expand your reach,
                and build a reputable portfolio.
              </p>
            </Col>
          </Row>
        </div>
      </div>

      <div className="containerfirst">
        <div className="box4">
          <h1 className="reg">Why Register as a Supplier?</h1>
          <p className="p5">
            Build trusted, lasting partnerships with a focus on growth.
          </p>
        </div>
      </div>

      <div>
        <div className="containersec">
          <Row justify="space-between">
            <Col xs={24} md={12} style={{ marginTop: "110px" }}>
              <h2 className="sign">Sign Up with Your Details</h2>
              <p className="p6">
                Create your profile by entering your basic information. This
                includes your business details and contact information to set up
                your account as a registered supplier.
              </p>
              <a className="a" href="#">
                Sign Up Now
              </a>
            </Col>
            <Col xs={24} md={12}>
              <img
                src={group}
                alt="Group"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
          </Row>
        </div>
      </div>

      <div>
        <div className="containersec">
          <Row justify={"space-between"}>
            <Col xs={24} md={10}>
              <img
                src={group1}
                alt="Group"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
            <Col
              xs={24}
              md={10}
              style={{
                marginTop: "80px",
                // justifyContent: "end",
                // textAlign: "center",
              }}
            >
              <h2 className="sign">Explore and Apply For Bids</h2>
              <p className="p6">
                Once registered, browse through live and upcoming bid
                opportunities on your dashboard. Select relevant bids and submit
                your application to showcase your offerings.
              </p>
              <a href="#" className="a">
                Start Bidding Now
              </a>
            </Col>
          </Row>
        </div>
      </div>

      <div>
        <div className="containersec">
          <Row justify="space-around">
            <Col xs={24} md={12} style={{ marginTop: "110px" }}>
              <h2 className="sign">Fulfill Bid Requirements</h2>
              <p className="p6">
                Upon bid approval, complete any required documentation,
                certifications, and fulfill the bid specifications. This ensures
                smooth onboarding and a successful partnership.
              </p>
              <a href="#" className="a">
                Start Bidding Now
              </a>
            </Col>
            <Col xs={24} md={12}>
              <img
                src={group2}
                alt="Group"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
          </Row>
        </div>
      </div>

      <div style={{ margin: "80px 0px" }}>
        <div className="containersec">
          <h1 className="bus">Ready to Grow Your Business?</h1>

          <p className="p7">Join Our Supplier Network Today</p>

          <div className="lastbtn">
            <Button className="firstbtn">Get Started</Button>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="containerfirst">
          <p className="p8">© 2024 Capsitech. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default VendorWebPage;
